import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ContextProvider from "./GlobalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <ContextProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true, // Enables relative paths in nested routes
          v7_fetcherPersist: true, // Retains fetcher state during navigation
          v7_normalizeFormMethod: true, // Normalizes form methods (e.g., POST or GET)
          v7_partialHydration: true, // Supports partial hydration for server-side rendering
          v7_skipActionErrorRevalidation: true, // Prevents revalidation when action errors occur
        }}
      >
        <App />
      </BrowserRouter>
    </ContextProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
